// extracted by mini-css-extract-plugin
export default {"drawer":"SelectWarehouseMapMobileYandex_drawer__sl8Nk"};